module.exports = __webpack_public_path__ + "img/about-us.bc5b62ae.jpg";